<template>
  <div class="common-box">
    <el-form
      inline
      ref="form"
      class="search-form common-box-search-form"
      label-position="right"
      :model="form"
      label-width="100px"
    >
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="使用单位：">
            <el-select
              size="mini"
              v-model="form.propertyUnitId"
              filterable
              placeholder="请选择所属单位"
              clearable
              reserve-keyword
              :remote="true"
              @change="handleSearchListData"
              :remote-method="searchUnitList"
              @visible-change="searchUnitList('')"
            >
              <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="item.unitName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属项目：">
            <el-select
              size="mini"
              v-model="form.projectId"
              filterable
              placeholder="请选择所属项目"
              clearable
              reserve-keyword
              :remote="true"
              @change="handleSearchListData"
              :remote-method="searchProjectList"
              @visible-change="searchProjectList('')"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.projectName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用编号：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.useCertificateNumber"
              placeholder="请输入使用编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="省市区：" class="input-with-col2">
            <AddreassSelect
              :isSearch="true"
              :warning="addressWarn"
              :showDetailAddress="showDetailAddress"
              :addressName="addressName"
              @change="setPojectAddress"
            ></AddreassSelect>
          </el-form-item>

          <el-form-item label="电梯位置：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.liftLocation"
              placeholder="请输入电梯位置"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="所属部门：">
            <el-cascader
              placeholder="请选择所属部门"
              :options="departmentTree"
              :props="propsTree"
              filterable
              size="mini"
              @change="handleDepartment"
              ref="cascader"
              collapse-tags
              v-model="departmentIdList"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="工单编号：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.orderNo"
              placeholder="请输入工单编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="添加时间：">
            <el-date-picker
              v-model="form.createTimeBetween"
              size="mini"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              unlink-panels
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="是否签字：">
            <el-select
              size="mini"
              v-model="form.signatureStatus"
              placeholder="请选择"
              clearable
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in isSignList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户是否签字：">
            <el-select
              size="mini"
              v-model="form.customerSignatureStatus"
              placeholder="请选择"
              clearable
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in isSignList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="超期：">
            <el-select
              size="mini"
              v-model="form.overdueStatus"
              placeholder="请选择"
              clearable
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in isSignList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="位置异常：">
            <el-select
              size="mini"
              v-model="form.locationStatus"
              placeholder="请选择"
              clearable
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in isSignList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推送状态：">
            <el-select
              size="mini"
              v-model="form.pushStatus"
              placeholder="请选择"
              clearable
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in pushStatusList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维保类型：" prop="maintainType">
            <el-select
              size="mini"
              v-model="form.maintainType"
              filterable
              placeholder="请选择维保类型"
              clearable
              reserve-keyword
            >
              <el-option
                v-for="item in maintainTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="审核状态：" prop="processStatus">
            <el-select
              size="mini"
              v-model="form.processStatus"
              filterable
              placeholder="请选择审核状态"
              clearable
              reserve-keyword
            >
              <el-option
                v-for="item in processStatusDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item.dictionaryCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="强制完成状态：" prop="forceCompleteStatus">
            <el-select
              size="mini"
              v-model="form.forceCompleteStatus"
              filterable
              placeholder="请选择强制完成状态"
              clearable
              reserve-keyword
            >
              <el-option
                v-for="item in WBQZWCDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item.dictionaryCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="handleDelete"
          v-if="hasRole['WBGDSC']"
        >删除
        </el-button
        >
        <el-button
          size="mini"
          type="primary"
          @click="exportEXAIL"
          plain
          class="plr28"
          v-if="hasRole['WBGDDCEXCEL']"
        >导出excel
        </el-button
        >
        <el-button
          size="mini"
          type="primary"
          @click="exportPDF"
          plain
          class="plr28"
          v-if="hasRole['WBGDDCPDF']"
        >导出pdf
        </el-button
        >
        <el-button
          size="mini"
          type="primary"
          @click="exportBatchPDF"
          plain
          class="plr28"
          v-if="hasRole['PLWBGDDCPDF']"
        >批量导出pdf
        </el-button
        >
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>

          <el-table-column
            show-overflow-tooltip
            prop="projectName"
            fixed="left"
            label="项目名称"
            width="160"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="liftLocation"
            label="电梯位置"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="locationStatusName"
            label="位置异常"
            width="100"
          >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.locationStatus == 1" type="success"  effect="dark" size="mini">{{scope.row.locationStatusName}}</el-tag>
            <el-tag v-if="scope.row.locationStatus == 2" type="danger"  effect="dark" size="mini">{{scope.row.locationStatusName}}</el-tag>
          </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="customerSignatureStatusName"
            label="客户签字"
            width="90"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="maintainTypeName"
            label="维保类型"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="processStatusName"
            label="审核状态"
            width="100"
          >
          <template slot-scope="scope">
             <el-tag v-if="scope.row.processStatus == 0" type="warning" effect="dark" size="mini">未审核</el-tag>
             <el-tag v-if="scope.row.processStatus == 1" type="success" effect="dark" size="mini">审核通过</el-tag>
             <el-tag v-if="scope.row.processStatus == 2" type="danger" effect="dark" size="mini">审核未通过</el-tag>
          </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="推送96333状态" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.pushStatus == 0" type="warning" effect="dark" size="mini">未推送</el-tag>
              <el-tag v-if="scope.row.pushStatus == 1" type="success"  effect="dark" size="mini">推送成功</el-tag>
              <el-tag v-if="scope.row.pushStatus == 2" type="danger"  effect="dark" size="mini">推送失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="operatorUserName"
            label="维保员"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="startTime"
            label="开始时间"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="endTime"
            label="结束时间"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="planTime"
            label="计划时间"
            width="150"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            prop="elapsedTime"
            label="耗时"
            width="90"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="signatureStatusName"
            label="签字"
            width="90"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="overdueStatusName"
            label="超期"
            width="90"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="propertyUnitName"
            label="使用单位"
            width="250"
          ></el-table-column>
           <el-table-column
            show-overflow-tooltip
            prop="orderNo"
            label="工单编号"
            width="160"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="forceCompleteStatusName"
            label="强制完成状态"
            width="160"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.forceCompleteStatus == 1" type="success"  effect="dark" size="mini">{{ scope.row.forceCompleteStatusName }}</el-tag>
              <el-tag v-if="scope.row.forceCompleteStatus == 2" type="danger"  effect="dark" size="mini">{{ scope.row.forceCompleteStatusName }}</el-tag>
            </template>  
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="preOrderNo"
            label="参考工单编号"
            width="160"
          ></el-table-column>
         
          <el-table-column
            show-overflow-tooltip
            prop="electronicWorkOrderStatusName"
            label="电子工单"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="templateName"
            label="模板名称"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="pushErrorMessage"
            label="推送失败原因"
            width="200"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="contactsPhone"
            label="省市区"
            width="100"
          >
            <template slot-scope="scope"
            >{{
                scope.row.provinceName ? scope.row.provinceName + "," : ""
              }}{{
                scope.row.provinceName ? scope.row.provinceName + "," : ""
              }}{{ scope.row.districtName }}
            </template
            >
          </el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="170px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                v-if="hasRole['WBGDCK']"
                @click="handleCheck(scope.row)"
              >查看
              </el-button
              >
              <div class="btn-divide" v-if="hasRole['WBGDCK']"></div>
              <el-button
                size="mini"
                v-if="hasRole['WBGDSC']"
                type="text"
                @click="handleDeleteUnit(scope.row)"
              >删除
              </el-button>
              <div class="btn-divide" v-if="hasRole['TS96333']"></div>
              <el-button
                size="mini"
                v-if="hasRole['TS96333']"
                type="text"
                @click="handlePushOrder(scope.row)"
              >推送
              </el-button>
              <div class="btn-divide" v-if="hasRole['copy']"></div>
              <el-button
                size="mini"
                v-if="hasRole['copy']"
                type="text"
                @click="handleCopyResult(scope.row)"
              >复制工单
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <check-order
      v-if="checkOrder"
      :editData="orderDetail"
      @cancel="checkOrder = false"
    ></check-order>
    <CopyOrder
      v-if="copyResult"
      :editData="orderDetail"
      @cancel="copyResult = false"
    ></CopyOrder>
  </div>
</template>

<script>
import {getDepartmentTree} from "@/api/ElevatorManagement";
import {
  getMaintainOrderList,
  deleteOrder,
  exportPDF,
  exportEXAIL,
  getProjectSimpleList,
  getPropertyUnitSimpleList,
  orderPush,
  batchExportPDF,
} from "@/api/MaintenanceWorkOrder";
import AddreassSelect from "@/components/AddreassSelect/AddreassSelect";
import CheckOrder from "./components/CheckOrder";
import CopyOrder from "./components/CopyOrder.vue";
import { getMaintainTypeList } from "@/api/MaintenancePlan";
import { mapState } from "vuex";
export default {
  name: "MaintenanceWorkOrder",
  components: {
    CopyOrder,
    CheckOrder,
    AddreassSelect,
  },
  data() {
    return {
      form: {
        departmentIdList: [],
        propertyUnitId: "",
        projectId: "",
        useCertificateNumber: "",
        cityCode: "",
        districtCode: "",
        provinceCode: "",
        liftLocation: "",
        orderNo: "",
        startCreateTime: "",
        endCreateTime: "",
        createTimeBetween: null,
        signatureStatus: "",
        overdueStatus: "",
        locationStatus: "",
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      checkOrder: false,
      orderDetail: {},
      unitList: [],
      projectList: [],
      addressWarn: false,
      showDetailAddress: false,
      addressName: "省市区",
      isSignList: [
        {
          code: 1,
          name: "是",
        },
        {
          code: 2,
          name: "否",
        },
      ],
      pushStatusList: [
        {
          code: '0',
          name: "未推送",
        },
        {
          code: '1',
          name: "推送成功",
        },
        {
          code: '2',
          name: "推送失败",
        },
      ],
      departmentTree: [],
      propsTree: {
        multiple: true,
        value: "id",
        label: "departmentName",
        children: "childrenList",
        // checkStrictly: true
      },
      copyResult: false,
      departmentIdList: [],
      maintainTypeList: []
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },

     ...mapState("common/dictionary", ["processStatusDicts",'WBQZWCDicts']),
  },
  created() {
    this.getListData();
    this.getDepartmentTree();
    this.getMaintainTypeList();
  },
  methods: {
    async getMaintainTypeList() {
      const res = await getMaintainTypeList()
      if (res.code === 200) {
        this.maintainTypeList = res.data
      }
    },
    async getDepartmentTree() {
      const res = await getDepartmentTree({pageIndex: 1, pageSize: 1000});
      if (res.code === 200) {
        this.departmentTree = res.data;
      }
    },
    async getListData() {
      this.tableLoading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      if (this.form.createTimeBetween) {
        delete params.createTimeBetween;
        params.endCreateTime = this.form.createTimeBetween[1];
        params.startCreateTime = this.form.createTimeBetween[0];
      }
      const res = await getMaintainOrderList(params);
      if (res.code === 200) {
        this.total = res.data.total;
        this.list = res.data.list;
      }
      this.tableLoading = false;
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteUnit(row) {
      const idList = [row.orderId];
      this.deleteOrder(idList);
    },
    handlePushOrder(row) {
      const orderIdList = [row.orderId];
      this.$confirm("确定推送96333?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await orderPush({orderIdList});
        if (res.code === 200) {
          this.$message.success("推送成功");
          this.getListData();
        }
      }).catch((err) => {
          console.log(err);
        });
    },
    handleCheck(row) {
      this.orderDetail = row;
      this.checkOrder = true;
    },
    exportBatchPDF() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要导出的行");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.orderId);
      batchExportPDF({idList});
    },
    handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.orderId);
      this.deleteOrder(idList);
    },
    handleCopyResult(row) {
      this.orderDetail = row;
      this.copyResult = true;
    },
    deleteOrder(idList) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteOrder({idList});
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    exportPDF() {
      // const params = {
      //   pageIndex: this.pageIndex,
      //   pageSize: this.pageSize
      // }
      // for(let key in this.form) {
      //   if (this.form[key])
      //     params[key] = this.form[key]
      // }
      if (
        !this.multipleSelection.length ||
        this.multipleSelection.length != 1
      ) {
        this.$message.warning("请选择要导出的一行，仅支持单个导出");
        return;
      }
      exportPDF({orderId: this.multipleSelection[0].orderId});
    },
    exportEXAIL() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      exportEXAIL(params);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    async searchUnitList(keyword) {
      const res = await getPropertyUnitSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.unitList = res.data;
      }
    },
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    setPojectAddress(data) {
      this.form.address = data.addressData; // 项目地址 详细地址
      this.form.provinceCode = data.provinceCode; // 项目地址省级 code
      this.form.provinceName = data.provinceName; // 项目地址省级 name
      this.form.cityCode = data.cityCode; // 项目地址城市 code
      this.form.cityName = data.cityName; // 项目地址城市 name
      this.form.districtCode = data.townCode; // 项目地址区级 code
      this.form.districtName = data.townName; // 项目地址区级 name
    },
    handleDepartment(val) {
      this.form.departmentIdList = [];
      const nodes = this.$refs.cascader.getCheckedNodes();
      nodes.forEach((item) => {
        this.form.departmentIdList.push(item.data.id);
      });
      this.handleSearchListData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/MaintenanceWorkOrder/MaintenanceWorkOrder.vue